import React, { useEffect, useState } from 'react';

import Translation from '@swf/components/Translation/Translation';
import useRequest from '@swf/core/hooks/useRequest';

import { LossLimitValue } from '../../../../types/responsibleGamingLimits';
import type { Limits, LossLimitType } from '../../../../types/responsibleGamingLimits';
import { getLossLimitAmountRestrictions } from '../../../../utils/responsibleGamingLimits';
import Container from '../../../Container/Container';
import ResponsibleGamingLimits from '../../../ResponsibleGamingLimits/ResponsibleGamingLimits';

import {
  TXTWCL_Loss_Limit_1,
  TXTWCL_Loss_limit_is_a_cap_on_how_muc_ELL,
  TXTWCL_Responsible_Gaming_Limits
} from './RMFLossLimit.messages.json';

const RMFLossLimit: React.FC = () => {
  const request = useRequest();
  const [limits, setLimits] = useState({} as Limits);

  useEffect(() => {
    request({ service: 'responsiblegaming.allapprovedlimits' }).subscribe(({ body }) => {
      const limits = body?.limits?.filter(
        (limit: LossLimitType) =>
          limit.type === LossLimitValue.Daily ||
          limit.type === LossLimitValue.Weekly ||
          limit.type === LossLimitValue.Monthly
      );
      setLimits(getLossLimitAmountRestrictions(limits));
    });
  }, [request]);

  return (
    <Container
      page={RMFLossLimit}
      headerProps={{
        title: <Translation {...TXTWCL_Responsible_Gaming_Limits} />
      }}
      pageTopTitle={<Translation {...TXTWCL_Loss_Limit_1} />}
      pageTopSubtitle={<Translation {...TXTWCL_Loss_limit_is_a_cap_on_how_muc_ELL} />}
    >
      <ResponsibleGamingLimits fieldName="rmf.loss" limits={limits} />
    </Container>
  );
};

RMFLossLimit.displayName = 'RMFLossLimit';

export default RMFLossLimit;
